<template>
    <div class="roleMag">
        <div class="roleMagList">
            <div class="addBtn"><el-button type="primary" @click="addRole">增加角色</el-button></div>
            <el-table :data="roleMagList" style="width: 100%" class="table">
                <el-table-column prop="rolename" label="角色" width="352">
                    <template slot-scope="scope">
                        <div v-if="Boolean(scope.row.add) == false">
                            <div><span>{{scope.row.rolename}}</span></div>
                        </div>
                        <div v-else>{{scope.row.rolename}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="描述"></el-table-column>
                <el-table-column prop="action" label="操作" class-name="actionTitle">
                    <template slot-scope="scope">
                        <div class="action">
                            <span @click="editRole(scope.row.innerid)">编辑</span>
                            |
                            <span @click="delRole(scope.row.innerid)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {deleteRole, getRoleList} from '@/api/subAccountApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'roleMag',
    data() {
        return {
            roleMagList: []
        }
    },
    created() {
        this._getRoleList()
    },
    methods: {
        addRole() {
            this.$router.push({name: 'RoleMsg'})
        },
        // 编辑角色
        editRole(innerid) {
            this.$router.push({name: 'RoleMsg', query: {id: innerid}})
        },
        // 删除角色
        delRole(innerid) {
            this.$confirm(`确定删除该角色吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                deleteRole({
                    data: {
                        innerid: innerid
                    },
                    success: data => {
                        this.setLoading(false)
                        this.$message.success('删除成功！')
                        this._getRoleList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        _getRoleList() {
            this.setLoading(true)
            getRoleList({
                data: {page: '1', pageSize: '10'},
                success: data => {
                    this.roleMagList = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    }
}
</script>
<style lang="scss">
@import '~common/scss/base';
    .roleMag{
        .roleMagList{
            .table{
                margin-top: 20px;
            }
            .actionTitle{
                text-align: right;
            }
            .action{
                text-align: right;
                color: #409EFF;
                span{
                    cursor: pointer;
                    position: relative;
                    top: 1px;
                }
            }
        }
        .roleMsg{
            .basicBox{
                width: 500px;
                .basicTitle{
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 20px;
                    .erect{
                        color: #409EFF;
                        position: relative;
                        top: -1px;
                    }
                }
                .el-form-item__label{
                    font-weight: 500;
                }
                .el-textarea__inner{
                    width: 400px;
                    height: 110px;
                    resize: none;
                }
            }
            .rootBox{
                margin-top: 40px;
                .rootTreeBox{
                    background: #F5F7FA;
                    padding-top: 20px;
                    margin-left: 10px;
                    .all{
                        margin-left: 20px;
                    }
                    .el-tree{
                        background: #F5F7FA;
                        margin-left: 14px;
                    }
                }
                .rootTitle{
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 20px;
                    .erect{
                        color: #409EFF;
                        position: relative;
                        top: -1px;
                    }
                }
                .el-checkbox__inner{
                    border: 1px dashed #ccc;
                }
            }
        }
    }
</style>
